import React from 'react';

import NumericCellEdit from '../Components/NumericCellEditor';
import DateCellEditor from '../Components/DateCellEditor';
import CheckboxEditor from '../Components/CheckboxEditor';

export const numericEditRenderer = onStartEdit => (editorProps, value, row, column, rowIndex, columnIndex) => (
	<NumericCellEdit
		editorProps={editorProps}
		value={value}
		row={row}
		col={column}
		rowIndex={rowIndex}
		columnIndex={columnIndex}
		onStartEdit={onStartEdit}
	/>
);

export const dateEditRenderer = (onStartEdit, label, validate) => (editorProps, value, row, column, rowIndex, columnIndex) => (
	<DateCellEditor
		editorProps={editorProps}
		value={value}
		row={row}
		col={column}
		label={label}
		rowIndex={rowIndex}
		columnIndex={columnIndex}
		onStartEdit={onStartEdit}
		validate={validate}
	/>
);

export const checkboxEditRenderer = onStartEdit => (editorProps, value, row, column, rowIndex, columnIndex) => (
	<CheckboxEditor
		editorProps={editorProps}
		value={value}
		row={row}
		col={column}
		rowIndex={rowIndex}
		columnIndex={columnIndex}
		onStartEdit={onStartEdit}
	/>
);
